import { Helper } from "../../core/util/helper";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { Config } from "../../core/config/config";
import { ComponentHelper } from "../../core/util/componentHelper";
import { IsSearchField } from "../../core/components/isSearchField";
import React from "react";
import ReactDOM from "react-dom";
export const openCopyDialog = (current: string = "") => {
    return new Promise<CopyObject[]>((resolve) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);


        const removeDialog = () => {
            root.unmount(targetElement[0]);
            targetElement[0].remove();
        }

        const onOk = (data: CopyObject[]) => {
            resolve(data)
            removeDialog();
        }

        root.render(<CopyDialog onOk={onOk} cancel={removeDialog} current={current} />);
    })
}

interface CopyDialogProps {
    onOk: (data: CopyObject[]) => void;
    cancel: () => void;
    current: string;
}
class CopyDialog extends React.Component<CopyDialogProps, { data: CopyObject[] }>{

    private factory = ComponentHelper.createFactory();
    private button: HTMLElement;
    private animationDurationInSeconds = 0.45;
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.UserSettings.Dashboard.Copy.Entities"),
        open: true,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.props.cancel()
                }
            },
            {
                label: Helper.getTranslation("Standard.Kopieren"),
                action: () => {
                    this.props.onOk(this.state.data)
                },
                primary: true
            }
        ],
        afterClose: () => {
        },
        width: 375
    };
    
    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
    }

    private renderSearch = () => {
        const rowHeight = 18;
        const props = this.factory.getDefaultSearchFieldProps();
        props.value = "";
        props.field.autocompleteEnabled = true;
        props.field.autocompleteTemplate = `
            <div style='color: \\#212529; display: grid; grid-template-rows: ${rowHeight}px ${rowHeight}px; grid-template-columns: ${rowHeight * 2}px 10px 1fr'>
                <div style='grid-column: 1/2; grid-row: 1/3; display: flex; align-items: center; justify-content: center'>
                    #switch(data.EntityType){
                        case 0:
                            #<i class='fa-regular fa-user fa-2x'></i>#
                            break;
                        case 1:
                            #<i class='fa-regular fa-user-group fa-2x'></i>#
                            break;
                        case 2:
                            #<i class='fa-regular fa-users fa-2x'></i>#
                            break;
                    }#

                </div>
                <div style='grid-column: 3/4; grid-row: 1/2; display: flex; align-items: center; justify-content: flex-start; font-weight: bold'>
                    #=data.DisplayName#
                </div>
                <div style='grid-column: 3/4; grid-row: 2/3; display: flex; align-items: center; justify-content: flex-start; font-weight: lighter'>
                #switch(data.EntityType){
                    case 0:
                        #${Helper.getTranslation("Standard.Benutzer")}#
                        break;
                    case 1:
                        #${Helper.getTranslation("Field.Ressource.gruppe")}#
                        break;
                    case 2:
                        #${Helper.getTranslation("Field.Ressource.obergruppe")}#
                        break;
                }#
                </div>
            </div>
        `
        props.field.autocompleteUrl = `Dashboard/GetEntitiesToCopy?ignore=${this.props.current}`; 
        props.field.autocompleteDataTextField = "DisplayName";
        props.field.searchButtonEnabled = false;
        props.field.clearButtonEnabled = false;
        props.onChange = (_, __, dataItem: CopyObject) => {
            this.add(dataItem)
        }
        return (
            <IsSearchField {...props} />
        );
    }

    private add = (item: CopyObject) => {
        let data = this.state.data;
        data.push(item)
        data = data.filter((value, index, array) => {
            return array.findIndex(i => i.Id == value.Id) === index;
        })
        this.setState({ data: data }, () => {
            this.changeBtnActivity(data.length > 0);
        })
    }

    private onDelete = (id: string) => {
        const data = JSON.parse(JSON.stringify(this.state.data.filter(item => item.Id != id)));
        this.changeBtnActivity(data.length > 0);
        setTimeout(() => {
            this.setState({ data: data })
        }, this.animationDurationInSeconds * 1000)
    }

    private changeBtnActivity = (enabled: boolean) => {
        if (enabled) {
            this.button.removeAttribute("disabled")
        } else {
            this.button.setAttribute("disabled", "disabled")
        }
    }

    componentDidMount() {
        this.button = document.querySelector(".k-dialog button.k-button.k-button-solid-primary");
        this.changeBtnActivity(false);

        const dialog: HTMLElement = document.querySelector(".k-dialog")
        dialog.style.top = (window.innerHeight / 5) + "px";

        const input: HTMLInputElement = document.querySelector(".k-dialog input.k-input-inner");
        input.placeholder = Helper.getTranslation("WebSMS.UserSettings.Dashboard.Copy.Search");
    }

    private renderEntites = () => {
        return this.state.data.map((item) => {
            return (
                <React.Fragment key={item.Id}>
                    <EntityToCopy entity={item} onClick={this.onDelete} />
                </React.Fragment>
            );
        })
    }

    private getCSS = () => {
        return `
        @keyframes add_entity{
            0%{
                transform: scale(0);
                grid-template-rows: 0px 0px;
                border-width: 0;
                margin: 0;
                padding: 0;
            }

            50% {
                transform: scale(0);
                grid-template-rows: 18px 18px;
                border-width: 1px;
                margin: 2px 0;
                padding: 3px;

            }

            100% {
                transform: scale(1);
                grid-template-rows: 18px 18px;
                border-width: 1px;
                margin: 2px 0;
                padding: 3px;
            }
        }

        .entity_to_copy {
            display: grid;
            grid-template-rows: 18px 18px;
            grid-template-columns: 36px 10px 1fr 5px 36px;
            color: #212529;
            border: 1px solid #ced4da;
            margin: 2px 0;
            padding: 3px;
            border-radius: var(--border-radius);
            fill: #212529;
            max-height: 44px;
            animation-name: add_entity;
            animation-duration: ${this.animationDurationInSeconds.toString()}s;
        }



        @keyframes delete_entity{
            0% {
                transform: scaleX(1);
                grid-template-rows: 18px 18px;
                border-width: 1px;
                margin: 2px 0;
                padding: 3px;
            }

            50% {
                transform: scaleX(0);
                grid-template-rows: 18px 18px;
                border-width: 1px;
                margin: 2px 0;
                padding: 3px;
            }

            100% {
                transform: scaleX(0);
                grid-template-rows: 0px 0px;
                border-width: 0;
                margin: 0;
                padding: 0;
            }
        }


        .entity_to_copy.deleted {
            animation-name: delete_entity;
            animation-duration: ${this.animationDurationInSeconds.toString()}s;
            transform-origin: 0% 50%;
            transform: scale(0);
            grid-template-rows: 0px 0px;
            border-width: 0;
            margin: 0;
            padding: 0;
        }

            .entity_to_copy .delete_btn {
                grid-column: 5/6;
                grid-row: 1/3;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .entity_to_copy .delete_btn i {
                transition: all .3s ease-in-out;
            }

                .entity_to_copy .delete_btn:hover {
                    cursor: pointer
                }

                .entity_to_copy .delete_btn:hover i {
                    transform: scale(1.3);
                }
        
        `
    }

    render() {
        const maxAmountItems = 8;
        const itemHeightInPx = 44;

        return (
            <Dialog {...this.dialogProps}>
                <style>
                    {this.getCSS()}
                </style>
                {this.renderSearch()}
                <div style={{ overflowX: "auto", maxHeight: (maxAmountItems * itemHeightInPx) + "px", padding: this.state.data.length >= maxAmountItems ? "0 10px 0 0" : "0", margin: "10px 0 0 0" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        {this.renderEntites()}
                    </div>
                </div>
            </Dialog >
        );
    }
}

interface CopyObject {
    Id: string;
    EntityId: string;
    EntityType: number;
    DisplayName: string;
}

interface EntityToCopyProps {
    entity: CopyObject;
    onClick: (id: string) => void;
}

function EntityToCopy(props: EntityToCopyProps) {
    const maxLenght = 30; // wurde empirisch ermittelt
    let icon: string;
    let entityType: string;
    let [deleted, setDeleted] = React.useState(false);

    switch (props.entity.EntityType) {
        case 0:
            icon = "user";
            entityType = Helper.getTranslation("Standard.Benutzer");
            break;
        case 1:
            icon = "user-group";
            entityType = Helper.getTranslation("Field.Ressource.gruppe");
            break;
        case 2:
            icon = "users";
            entityType = Helper.getTranslation("Field.Ressource.obergruppe");
            break;
    }

    function onClick() {
        setDeleted(true);
        props.onClick(props.entity.Id)        
    }

    let displayName = props.entity.DisplayName;
    if (displayName.length >= maxLenght) {
        displayName = displayName.substring(0, maxLenght - 2) + "...";
    }

    return (
        <div className={"entity_to_copy" + (deleted ? " deleted" : "")} title={props.entity.DisplayName}>
            <div style={{ gridColumn: "1/2", gridRow: "1/3", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className={`fa-regular fa-${icon} fa-2x`}></i>
            </div>
            <div style={{ gridColumn: "3/4", gridRow: "1/2", display: "flex", alignItems: "center", justifyContent: "flex-start", fontWeight: "bold", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {displayName}
            </div>
            <div style={{ gridColumn: "3/4", gridRow: "2/3", display: "flex", alignItems: "center", justifyContent: "flex-start", fontWeight: "lighter" }}>
                {entityType}
            </div>
            <div className="delete_btn" onClick={onClick}>
                <i className={`fa-regular fa-times fa-lg`}></i>
            </div>
        </div>
    );
}
